/* Saíra — página do livro: galeria (setas, miniaturas, teclado e arraste) e quantidade.
   Mesmo comportamento de livro-vida.html; a quantidade agora alimenta o formulário de compra da Shopify. */
(function(){

  /* galeria do livro */
  function galeria(){
    var track=document.getElementById('track');
    if(!track||track.getAttribute('data-pronta')) return;
    var figs=track.querySelectorAll('figure');
    var prev=document.getElementById('prev'), next=document.getElementById('next');
    var thumbs=document.getElementById('thumbs');
    var i=0, n=figs.length;
    if(!n||!prev||!next||!thumbs) return;
    track.setAttribute('data-pronta','1');

    figs.forEach(function(f,k){
      var b=document.createElement('button');
      b.type='button';
      b.setAttribute('aria-label','Ver imagem '+(k+1));
      var im=f.querySelector('img');
      var src=f.getAttribute('data-thumb')||(im?im.getAttribute('src'):'');
      var t=document.createElement('img');
      t.src=src; t.alt='';
      b.appendChild(t);
      b.addEventListener('click',function(){ go(k); });
      thumbs.appendChild(b);
    });
    var tbs=thumbs.querySelectorAll('button');

    /* traz a miniatura ativa para a vista rolando só a fileira (a página não pula) */
    function mostra(b){
      if(!b) return;
      var t=thumbs.getBoundingClientRect(), r=b.getBoundingClientRect();
      if(r.left<t.left) thumbs.scrollBy({left:r.left-t.left,behavior:'smooth'});
      else if(r.right>t.right) thumbs.scrollBy({left:r.right-t.right,behavior:'smooth'});
    }

    function go(k){
      i=Math.max(0,Math.min(n-1,k));
      track.style.transform='translateX('+(-i*100)+'%)';
      prev.disabled = i===0;
      next.disabled = i===n-1;
      tbs.forEach(function(b,j){ b.setAttribute('aria-current', j===i?'true':'false'); });
      mostra(tbs[i]);
    }
    prev.addEventListener('click',function(){ go(i-1); });
    next.addEventListener('click',function(){ go(i+1); });

    var stage=track.parentNode;
    stage.setAttribute('tabindex','0');
    stage.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'){ e.preventDefault(); go(i-1); }
      if(e.key==='ArrowRight'){ e.preventDefault(); go(i+1); }
    });

    /* arrastar / deslizar (mouse, caneta e toque) */
    var x0=null, y0=null;
    function start(x,y){ x0=x; y0=y; }
    function end(x,y){
      if(x0===null) return;
      var dx=x-x0, dy=y-y0; x0=null; y0=null;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) go(dx<0 ? i+1 : i-1);
    }
    stage.addEventListener('pointerdown',function(e){ start(e.clientX,e.clientY); });
    stage.addEventListener('pointerup',function(e){ end(e.clientX,e.clientY); });
    stage.addEventListener('pointercancel',function(){ x0=null; y0=null; });
    stage.addEventListener('touchstart',function(e){
      var t=e.changedTouches[0]; start(t.clientX,t.clientY);
    },{passive:true});
    stage.addEventListener('touchend',function(e){
      var t=e.changedTouches[0]; end(t.clientX,t.clientY);
    },{passive:true});
    track.addEventListener('dragstart',function(e){ e.preventDefault(); });

    go(0);
  }

  /* quantidade: o número na tela e o campo "quantity" do formulário andam juntos */
  function quantidade(){
    var q=document.getElementById('qtd');
    if(!q||q.getAttribute('data-pronta')) return;
    q.setAttribute('data-pronta','1');
    var form=q.closest('form');
    var campo=form?form.querySelector('input[name="quantity"]'):null;
    var v=1;
    function poe(x){ v=x; q.textContent=v; if(campo) campo.value=v; }
    document.getElementById('minus').addEventListener('click',function(){ poe(Math.max(1,v-1)); });
    document.getElementById('plus').addEventListener('click',function(){ poe(Math.min(99,v+1)); });
  }

  function inicia(){ galeria(); quantidade(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',inicia); else inicia();
  /* editor de temas: a seção é redesenhada sem recarregar a página */
  document.addEventListener('shopify:section:load',inicia);
})();
